<template>
  <div class="match-result-list" v-loading="loading">
    <template v-if="list.length > 0">
      <div
        v-for="item in list"
        :key="item.music_id || item.song_id || item.object_id"
        class="match-result-list__card-wrap"
      >
        <div class="match-result-list__card">
          <div class="match-result-list__img">
            <div
              class="match-result-list__cover"
              @click="playItem(item)"
            >
              <!-- <div class="match-result-list__score">相似 {{ formatScore(item.song_score) }}%</div> -->
              <img class="match-result-list__cover-img" :src="item.logo" alt="">
              <div class="match-result-list__cover-status">
                <img
                  v-if="playingId === itemMusicId(item)"
                  src="~@/assets/svg/operation/play_icon.svg"
                >
                <img v-else src="~@/assets/svg/operation/pause_icon.svg">
              </div>
            </div>
            <div class="match-result-list__info">
              <p class="match-result-list__name" @click="playItem(item)">{{ item.name }}</p>
              <p
                class="match-result-list__labels"
                :title="labelText(item)"
              >{{ labelText(item) }}</p>
            </div>
          </div>

          <div class="match-result-list__wave">
            <MatchWave
              :ref="'wave_' + itemMusicId(item)"
              :music="item"
              :matches="item.matches || []"
              @play-start="onWavePlayStart(item)"
              @play-state="(playing) => onWavePlayState(item, playing)"
            />
          </div>

          <div class="match-result-list__op">
            <p class="match-result-list__time">{{ (item.time || item.duration) | formatTimeBySecond }}</p>
            <el-tooltip effect="dark" content="收藏音乐" placement="top">
              <img
                :src="require(`@/assets/svg/operation/${item.is_collect == 0 ? 'collect' : 'collected'}.svg`)"
                alt=""
                @click="handleMusicCollect(item)"
              >
            </el-tooltip>
            <el-tooltip effect="dark" content="分享音乐" placement="top">
              <img
                :src="require(`@/assets/svg/operation/share.svg`)"
                alt=""
                @click="handleShare('', item.object_id, item.type || 2, item.name)"
              >
            </el-tooltip>
            <!-- <el-tooltip effect="dark" content="单首购买" placement="top">
              <span class="match-result-list__buy" @click="handleBuyToInfo(item)">购买</span>
            </el-tooltip> -->
            <span class="match-result-list__buy" @click="handleBuyToInfo(item)">购买</span>
            <el-dropdown
              trigger="hover"
              placement="bottom"
              class="music-download-dropdown"
            >
              <span class="down">立即下载</span>
              <el-dropdown-menu
                slot="dropdown"
                :visible-arrow="false"
                :append-to-body="false"
                :offset="0"
                :popper-options="{ gpuAcceleration: false }"
              >
                <el-dropdown-item @click.native="handleDownWater(item)">
                  水印
                </el-dropdown-item>
                <el-tooltip effect="dark" content="使用会员下载高清素材" placement="top">
                  <el-dropdown-item @click.native="handleDownHD(item)">
                    <img :src="require(`@/assets/svg/operation/down_detail_icon.svg`)" alt="">
                    &nbsp;高清
                  </el-dropdown-item>
                </el-tooltip>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </template>
    <el-empty v-else-if="!loading" description="暂无相似结果" />
  </div>
</template>

<script>
import Buttons from '@/layout/mixins/Buttons'
import { getToken, getUserInfo } from '@/utils/author'
import { downloadByLink } from '@/utils/utils'
import { downloadWaterMusicLog } from '@/api/music'
import { reportUserDeed } from '@/utils/deed'
import MatchWave from './MatchWave.vue'

export default {
  name: 'MatchResultList',
  components: {
    MatchWave
  },
  mixins: [Buttons],
  props: {
    list: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      playingId: ''
    }
  },
  watch: {
    list() {
      this.playingId = ''
    }
  },
  methods: {
    itemMusicId(item) {
      return (item && (item.music_id || item.song_id || item.object_id)) || ''
    },
    getWaveRef(id) {
      const ref = this.$refs['wave_' + id]
      if (!ref) return null
      return Array.isArray(ref) ? ref[0] : ref
    },
    pauseOthers(exceptId) {
      const list = this.list || []
      list.forEach((item) => {
        const id = this.itemMusicId(item)
        if (!id || id === exceptId) return
        const wave = this.getWaveRef(id)
        if (wave) wave.pause()
      })
    },
    pauseAll() {
      const list = this.list || []
      list.forEach((item) => {
        const id = this.itemMusicId(item)
        if (!id) return
        const wave = this.getWaveRef(id)
        if (wave) wave.pause()
      })
      this.playingId = ''
    },
    stopGlobalMusic() {
      this.$store.dispatch('music/musicStop').catch(() => {})
      this.$store.commit('music/UPDATE_MUSIC_CONTROLS_VISIBLE', false)
    },
    onWavePlayStart(item) {
      const id = this.itemMusicId(item)
      this.stopGlobalMusic()
      this.pauseOthers(id)
      this.$emit('play-start')
    },
    playItem(item) {
      const id = this.itemMusicId(item)
      if (!id) return
      const wave = this.getWaveRef(id)
      if (!wave) return
      this.stopGlobalMusic()
      if (this.playingId === id && wave.isPlaying()) {
        wave.pause()
        return
      }
      this.pauseOthers(id)
      this.$emit('play-start')
      wave.play()
    },
    onWavePlayState(item, playing) {
      const id = this.itemMusicId(item)
      if (playing) {
        this.pauseOthers(id)
        this.playingId = id
        if (item.music_id) {
          reportUserDeed(window.location.href, 21, item.music_id)
        }
      } else if (this.playingId === id) {
        this.playingId = ''
      }
    },
    formatScore(score) {
      const n = Number(score)
      if (!Number.isFinite(n)) return 0
      return Math.round(n * 100)
    },
    labelText(item) {
      const labels = item && item.label
      if (!Array.isArray(labels)) return ''
      return labels.map((i) => i.name).filter(Boolean).join('，')
    },
    handleBuyToInfo(item) {
      reportUserDeed(window.location.href, 8, item.music_id)
      if (!(getToken() && getToken() !== '')) {
        this.$store.dispatch('user/openLogin')
        return
      }
      // this.$router.push(`/music-detail/${item.music_id}`)
      // 使用 window.open 在新标签页打开链接
      const routeUrl = this.$router.resolve({
        // path: `/music-detail/${item.music_id}`
        path: `/music-down-detail/${item.music_id}`
      })
      window.open(routeUrl.href, '_blank')
    },
    handleDownWater(item) {
      reportUserDeed(window.location.href, 23, item.music_id)
      if (!(getToken() && getToken() !== '')) {
        this.$store.dispatch('user/openLogin')
        return
      }
      if (!this.hasMember) {
        this.$router.push(`/music-down-detail/${item.music_id}`)
        return
      }
      const userInfo = getUserInfo()
      const userId = userInfo && userInfo.user_id
      const musicId = item.music_id
      downloadWaterMusicLog({ user_id: userId, music_id: musicId }).catch(() => {})
      downloadByLink(item.watermark_file_down)
    },
    handleDownHD(item) {
      reportUserDeed(window.location.href, 22, item.music_id)
      if (!(getToken() && getToken() !== '')) {
        this.$store.dispatch('user/openLogin')
        return
      }
      if (!this.hasMember) {
        this.$router.push(`/music-down-detail/${item.music_id}`)
        return
      }
      this.handleDownload(item, 'single')
    },
    async handleMusicCollect(item) {
      if (!(getToken() && getToken() !== '')) {
        this.$store.dispatch('user/openLogin')
        return
      }
      item.is_collect = item.is_collect === 0 ? 1 : 0
      await this.handleCollect(item.object_id, 2, {
        ...item,
        type: 2,
        labels: item.label
      }, false)
    }
  }
}
</script>

<style lang="scss" scoped>
.match-result-list {
  width: 100%;

  &__card-wrap {
    position: relative;
    padding: 15px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  &__score {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    padding: 1px 6px;
    font-size: 11px;
    line-height: 16px;
    color: #fff;
    background: rgba(229, 42, 13, 0.9);
    border-radius: 0 0 4px 0;
  }

  &__card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
  }

  &__img {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: pointer;
  }

  &__cover {
    position: relative;
    width: 70px;
    height: 70px;
    overflow: hidden;
  }

  &__cover-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: rgba(0, 0, 0, 0.2);
  }

  &__cover-status {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__info {
    margin-left: 12px;
    min-width: 0;
    width: 160px;
  }

  &__name {
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
    margin: 0 0 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__labels {
    margin: 0;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 17px;
    max-width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__wave {
    flex: 1;
    min-width: 140px;
    margin: 0 24px;
    min-height: 50px;
  }

  &__op {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    margin-left: auto;

    img {
      cursor: pointer;
      margin-right: 14px;
    }
  }

  &__time {
    margin: 0 26px 0 0;
    min-width: 36px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 17px;
  }

  &__buy {
    cursor: pointer;
    width: 60px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    color: #e52a0d;
    border: 1px solid #e52a0d;
  }

  .music-download-dropdown {
    position: relative;
    z-index: 1;
    overflow: visible;
    margin-left: 12px;
    display: inline-flex;
    align-items: stretch;
    vertical-align: middle;
  }

  .music-download-dropdown .down {
    position: relative;
    z-index: 2;
    width: 80px;
    height: 32px;
    box-sizing: border-box;
    background: #e52a0d;
    color: #ffffff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  .music-download-dropdown ::v-deep .el-dropdown-menu.el-popper {
    margin-top: 0 !important;
    padding: 0;
    min-width: 80px;
    width: 80px;
    background: #e52a0d !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 0 4px 4px;
    z-index: 1;
  }

  .music-download-dropdown ::v-deep .el-dropdown-menu__item {
    font-size: 14px;
    line-height: 22px;
    height: 30px;
    padding: 8px 10px !important;
    margin: 0;
    color: #ffffff !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;

    img {
      width: 16px;
      height: 16px;
      margin-right: 0;
    }

    &:not(:last-child) {
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    &:hover {
      color: #ffffff !important;
      background-color: rgba(0, 0, 0, 0.12) !important;
    }
  }
}
</style>
